import * as SearchModels from '../../models/brand-managament/brand-managamentSearch';
import * as Models from '../../models/brand-managament/brand-managament';
import { BrandsModel } from '../../models/tyre/brands';

export class GetProducerDictionary {
  static readonly type = '[BrandManagament] GetProducerDistionary';
  constructor() { }
}

export class GetBrandManagamentList {
  static readonly type = '[BrandManagament] GetBrandManagamentList';
  constructor(public Search: SearchModels.BrandManagamentSearchModel) { }
}

export class Refresh {
  static readonly type = '[BrandManagament] BrandManagamentRefresh';
  constructor(public Producer: Models.BrandManagamentModel) { }
}

export class SetBrandManagamentSearch {
  static readonly type = '[BrandManagament] SetBrandManagamentSearch';
  constructor(public Search: SearchModels.BrandManagamentSearchModel) { }
}

export class SetBrandManagamentListPage {
  static readonly type = '[BrandManagament] SetBrandManagamentListPage';
  constructor(public Search: SearchModels.BrandManagamentSearchModel) { }
}

export class ResetBrandManagamentSearch {
  static readonly type = '[BrandManagament] ResetBrandManagamentSearch';
  constructor() { }
}

export class DisposeSearch {
  static readonly type = '[BrandManagament] DisposeSearch';
  constructor() { }
}

export class SetBrand {
  static readonly type = '[BrandManagament] SetBrand';
  constructor(public Brand: Models.BrandManagamentModel) { }
}

export class SetProducer {
  static readonly type = '[BrandManagament] SetProducer';
  constructor(public Producer: Models.BrandManagamentModel) { }
}

export class DeleteBrandItem {
  static readonly type = '[BrandManagament] DeleteBrandItem';
  constructor(public BrandId: number) { }
}

export class DeleteProducerItem {
  static readonly type = '[BrandManagament] DeleteProducerItem';
  constructor(public ProducerId: number) { }
}

export class InsertBrand {
  static readonly type = '[BrandManagament] InsertBrand';
  constructor(public Brand: Models.BrandManagamentModel) { }
}

export class InsertProducer {
  static readonly type = '[BrandManagament] InsertProducer';
  constructor(public Producer: Models.BrandManagamentModel) { }
}
